import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { Label } from '@/components/ui/label'

// `children` lets a caller append extra options inside the same radio group.
// `id` is the control-id prefix; each radio is `${id}-${index}`.
const ChoiceField = ({ field, id: idPrefix = field.id, value, onChange, disabled, children }) => (
  <RadioGroup
    value={value || ''}
    onValueChange={onChange}
    disabled={disabled}
    className="flex flex-wrap gap-4"
  >
    {field.choices.map((choice, index) => {
      const id = `${idPrefix}-${index}`
      return (
        <div key={choice} className="flex items-center gap-2">
          <RadioGroupItem value={choice} id={id} className="h-5 w-5 border-2" />
          <Label htmlFor={id} className="text-sm font-normal cursor-pointer">{choice}</Label>
        </div>
      )
    })}
    {children}
  </RadioGroup>
)

export default ChoiceField
